// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "actions-298wm";
var _5 = "addSegment-3R4GQ";
var _6 = "removeSegment-1eO81";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "mobile", _4 as "actions", _5 as "addSegment", _6 as "removeSegment" }
export default { "__esModule": _1, "tablet_only": _2, "mobile": _3, "actions": _4, "addSegment": _5, "removeSegment": _6 }
